<template>
  <side-panel-inner
    :headerTitle="`New ${$store.state.documents.docType.singular} version`"
    class="p-document-create"
  >
    <template slot="actions">
      <base-button primary="true" @click="onSubmit" iconBefore="pencil"
        >Submit</base-button
      >
    </template>

    <document-meta v-if="document" :document="document"></document-meta>

    <hr />

    <message type="error" v-if="showValidationMessage">
      <h3>Form Invalid</h3>
      <p>The form is invalid, please check and try again.</p>
      <ul>
        <li v-for="(error, index) in errors.items" :key="index">
          {{ error.msg }}
        </li>
      </ul>
    </message>

    <form action v-if="!loading">
      <!-- Major or Minor Version -->
      <form-options
        label="What type of version?"
        v-model="newVersion"
        name="new_version"
        :options="versionOptions"
        v-validate="{ required: true }"
        data-vv-as="new version"
        :error="errors.first('new_version')"
      ></form-options>

      <form-field
        v-if="showCustom"
        full-width
        placeholder="Add a custom version number here"
        v-model="newVersionCustom"
      ></form-field>

      <form-field
        full-width
        :label="(docType.singular + ' Title') | capitalize"
        name="document_title"
        v-model="document.current_version.title"
        v-validate="{ required: true, min: 5 }"
        data-vv-as="title"
        :error="errors.first('document_title')"
        :max-length="150"
        :show-counter="true"
        required
      ></form-field>

      <form-field
        label="Responsible Users"
        name="responsible_users"
        required
        :helper-text="'Give people responsibility of this ' + docType.singular"
      >
        <div class="row">
          <div class="col-xs-12">
            <form-label small required>Primary</form-label>
            <user-select
              v-model="document.primary_user"
              id="document_primary_user"
              name="document_primary_user"
              v-validate="{ required: true }"
              data-vv-as="primary user"
              :error="errors.first('document_primary_user')"
              :permissions="permissions"
              @input="markUserChange"
            ></user-select>
          </div>
          <div class="col-xs-12">
            <form-label small required>Secondary</form-label>
            <user-select
              v-model="document.secondary_user"
              id="document_secondary_user"
              name="document_secondary_user"
              v-validate="{ required: true, is_not: document.primary_user }"
              data-vv-as="secondary user"
              :error="errors.first('document_secondary_user')"
              :permissions="permissions"
              @input="markUserChange"
            ></user-select>
          </div>
        </div>
      </form-field>

      <!-- File Upload -->
      <form-field
        label="File upload"
        name="document_file"
        helper-text="Upload your document"
        required
      >
        <file-upload
          :fileTypes="documentFileTypes"
          name="document_file"
          :resource="docType.singular"
          @uploaded="onFileUploaded"
          :docType="docType"
          v-validate="{ required: true }"
          data-vv-as="file upload"
          :error="errors.first('document_file')"
          :bypassDuplicate="false"
        ></file-upload>
      </form-field>

      <!-- Choose Review Date -->
      <form-field
        label="Choose Review Date"
        name="document_review_date"
        helper-text="Select your document review date"
        required
      >
        <form-datepicker
          small
          v-model="document.reviewDate"
          name="document_review_date"
          v-validate="{ required: true }"
          data-vv-as="review date"
          id="document_review_date"
          format="DD / MM / YYYY"
          :disabled-dates="{ to: new Date() }"
          :error="errors.first('document_review_date')"
        ></form-datepicker>
      </form-field>
    </form>

    <loading v-else></loading>
  </side-panel-inner>
</template>

<script>
import FileUpload from "@/components/FileUpload";
import UserSelect from "@/components/UserSelect";
export default {
  name: "document-create-version",

  components: {
    FileUpload,
    UserSelect,
  },

  data() {
    return {
      permissions: ["add_policies"],
      loading: true,
      document: null,
      newVersion: null,
      newVersionCustom: null,
      newFileId: null,
      showValidationMessage: false,
      updateDocument: false,
      showCustom: false,
    };
  },

  created() {
    this.retrieveDocument();
  },

  methods: {
    markUserChange() {
      this.updateDocument = true;
    },
    onSubmit() {
      this.loading = true;

      this.$validator.validate().then((result) => {
        if (!result) {
          this.loading = false;
          this.showValidationMessage = true;
        } else {
          this.showValidationMessage = false;
          this.createNewVersion();
        }
      });
    },

    createNewVersion() {
      const documentId = this.$route.params.id;
      const version = {
        version: this.newVersionCustom
          ? this.newVersionCustom
          : this.newVersion,
        file_id: this.newFileId,
        title: this.document.current_version.title,
        review_date: this.$dayjs(this.document.reviewDate).format("YYYY-MM-DD"),
      };

      this.$store
        .dispatch("documents/createVersion", { documentId, version })
        .then((createdVersion) => {
          // update the document with new users if we need to
          const documentData = {
            id: documentId,
            primary_user_id: this.document.primary_user.id,
            secondary_user_id: this.document.secondary_user.id,
          };

          console.log(documentData);
          console.log("update?", this.updateDocument);

          if (this.updateDocument) {
            this.$store
              .dispatch("documents/updateDocument", documentData)
              .then(() => {
                this.$router.push({
                  name: "AdminDocumentPreview",
                  params: { id: documentId },
                });
              })
              .catch((err) => {
                console.log(documentData);
                console.log("err", { ...err });
                this.showValidationMessage = true;
              });
          } else {
            this.$router.push({
              name: "AdminDocumentPreview",
              params: { id: documentId },
            });
          }
        })
        .catch((error) =>
          console.log("failed to create a new version", { error })
        );
    },

    onFileUploaded(fileData) {
      this.newFileId = fileData.id;
    },

    retrieveDocument() {
      const vm = this;
      const documentId = this.$route.params.id;

      this.$store.dispatch("documents/read", documentId).then((document) => {
        this.document = {
          ...document,
          reviewDate: vm
            .$dayjs()
            .add(1, "year")
            .format("YYYY-MM-DD"),
        };
        console.log(document);
        vm.loading = false;
      });
    },
  },

  computed: {
    onCloseAction() {
      if (this.$route.meta.isAdmin) {
        return `/admin/documents/${this.$store.state.documents.docType.plural}`;
      }
      return `/documents/${this.$store.state.documents.docType.plural}`;
    },
    versionOptions() {
      const majorVersion = parseInt(this.document.current_version.version) + 1;
      const minorVersion =
        parseFloat(this.document.current_version.version) + 0.1;

      return [
        {
          label: `Major (v${majorVersion}.0)`,
          value: majorVersion,
          content: "",
        },
        {
          label: `Minor (v${minorVersion.toFixed(1)})`,
          value: minorVersion,
          content: "",
        },
        {
          label: "Custom",
          value: "custom",
          content: "",
        },
      ];
    },

    documentFileTypes() {
      if (this.docType.singular === "policy") {
        return ["pdf","xls","xlsx"];
      }

      return null;
    },

    docType() {
      return this.$store.state.documents.docType;
    },
  },
  watch: {
    newVersion(newValue, oldValue) {
      this.showCustom = newValue == "custom";
    },
  },
};
</script>
